import { atom } from 'nanostores';
import type { Command, ShellId } from '~/lib/shell/driver';
import { ShellDriver } from '~/lib/shell/driver';
import { hmrPropertyFactory } from '~/utils/hmr';

const hmr = hmrPropertyFactory('TerminalStore');

export const BOLT_TERMINAL = -2;
export const DEPLOY_TERMINAL = -1;

export class TerminalStore {
  terminalDriver = new ShellDriver();
  deployDriver = new ShellDriver();

  @hmr()
  showTerminal = atom(false);

  @hmr()
  activeTerminal = atom(BOLT_TERMINAL);

  @hmr()
  terminals = atom<number[]>([BOLT_TERMINAL, DEPLOY_TERMINAL, 0]);

  #nextTerminalId = 1;

  addTerminal() {
    const terminalId = this.#nextTerminalId++;

    this.terminals.set([...this.terminals.get(), terminalId]);

    return terminalId;
  }

  remmoveTerminal(terminalId: number) {
    const terminals = this.terminals.get();

    const index = terminals.indexOf(terminalId);

    if (index === -1) {
      return;
    }

    const nextActive = terminals[index + 1] ?? terminals[index - 1] ?? BOLT_TERMINAL;

    this.terminals.set([...terminals.slice(0, index), ...terminals.slice(index + 1)]);

    this.activeTerminal.set(nextActive);
  }

  toggleTerminal(value?: boolean, shellId?: ShellId) {
    this.showTerminal.set(value !== undefined ? value : !this.showTerminal.get());

    if (shellId === 'deploy') {
      this.activeTerminal.set(DEPLOY_TERMINAL);
    } else {
      this.activeTerminal.set(BOLT_TERMINAL);
    }
  }

  processCommand(command: Command) {
    if (command.shellAction.shellId === 'bolt') {
      this.terminalDriver.processCommand(command);
    } else if (command.shellAction.shellId === 'deploy') {
      this.deployDriver.processCommand(command);
    }
  }

  getCurrentCommand() {
    return this.terminalDriver.getCurrentCommand();
  }

  restartCurrentCommand() {
    this.terminalDriver.restartCurrentCommand();
  }
}
